import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import SeamlessBackground from '../components/SeamlessBackground';
import { CANDIDATE_APPLY_ROUTE } from '../constants';

const Blog: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#022334] text-white font-sans antialiased relative">
            {/* Seamless CSS Background */}
            <SeamlessBackground />

            {/* Content */}
            <div className="relative z-10">
                <Navbar />
                <main className="relative">
                    {/* Hero Section with Blog Title */}
                    <section
                        className="relative px-4 sm:px-8 lg:px-12"
                        style={{
                            paddingTop: '200px',
                            paddingBottom: '80px',
                            minHeight: '545px',
                            marginTop: '-120px',
                        }}
                    >
                        {/* Background Image */}
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '545px',
                            backgroundImage: 'url(/background/blog_bg-optimized.png)',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            pointerEvents: 'none',
                            zIndex: 0,
                        }} />

                        {/* Dark overlay gradients */}
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '545px',
                            background: 'linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)',
                            backgroundBlendMode: 'multiply',
                            pointerEvents: 'none',
                            zIndex: 1,
                        }} />
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '545px',
                            background: 'linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%)',
                            backgroundBlendMode: 'multiply',
                            transform: 'matrix(1, 0, 0, -1, 0, 0)',
                            pointerEvents: 'none',
                            zIndex: 1,
                        }} />

                        <div className="container mx-auto max-w-[1630px] relative" style={{ zIndex: 2 }}>
                            {/* Back Button */}
                            <Link
                                to="/"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    padding: '12px 30px',
                                    gap: '8px',
                                    background: 'linear-gradient(180deg, rgba(61, 66, 68, 0) -40.91%, rgba(158, 170, 176, 0.248) 132.95%)',
                                    boxShadow: 'inset 0px 8px 10px rgba(246, 249, 255, 0.08)',
                                    filter: 'drop-shadow(0px 6px 40px rgba(255, 255, 255, 0.08))',
                                    backdropFilter: 'blur(50px)',
                                    borderRadius: '10px',
                                    fontFamily: 'Manrope',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '150%',
                                    color: '#C0C0BF',
                                    textDecoration: 'none',
                                    marginBottom: '40px',
                                }}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15 10H5M5 10L10 15M5 10L10 5" stroke="#8D8D8C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Back to home
                            </Link>

                            {/* Blog Title */}
                            <h1
                                style={{
                                    fontFamily: 'Manrope',
                                    fontWeight: 700,
                                    fontSize: 'clamp(40px, 5vw, 75px)',
                                    lineHeight: '100%',
                                    letterSpacing: '-0.011em',
                                    color: '#FFFFFF',
                                    marginBottom: '40px',
                                    maxWidth: '1509px',
                                }}
                            >
                                How artificial intelligence is reshaping the way companies connect with top talent
                            </h1>

                            {/* Date */}
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    padding: '16px 0',
                                }}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span
                                    style={{
                                        fontFamily: 'Manrope',
                                        fontWeight: 500,
                                        fontSize: '18px',
                                        lineHeight: '150%',
                                        color: '#F0F0F0',
                                    }}
                                >
                                    May 01, 2025
                                </span>
                            </div>
                        </div>
                    </section>

                    {/* Article Content */}
                    <section className="px-4 sm:px-8 lg:px-12 py-16">
                        <div className="container mx-auto max-w-[1630px]">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '64px' }}>
                                {/* Section 1 */}
                                <div>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(32px, 3vw, 48px)',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        AI and the Future of Hiring
                                    </h2>
                                    <p
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 200,
                                            fontSize: 'clamp(16px, 1.5vw, 24px)',
                                            lineHeight: '150%',
                                            textAlign: 'justify',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                        }}
                                    >
                                        Recruiting has always been about finding the right person at the right time. But in today's fast-moving job market, traditional methods are falling short. Most recruiters rely on job boards and headhunters, yet the reality is that nearly 70% of professionals are passive candidates — not actively looking for jobs, but open to new opportunities. This is where artificial intelligence (AI) is making a difference.
                                    </p>
                                </div>

                                {/* Section 2 */}
                                <div>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(32px, 3vw, 48px)',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        1. Why Traditional Recruiting Isn't Enough
                                    </h2>
                                    <p
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 200,
                                            fontSize: 'clamp(16px, 1.5vw, 24px)',
                                            lineHeight: '150%',
                                            textAlign: 'justify',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                        }}
                                    >
                                        Job boards attract only a fraction of the workforce. Recruiters spend countless hours sorting résumés, often with low placement success rates. Passive talent — the majority of skilled professionals — remains invisible in this process. AI solves this by going beyond résumés and job postings, analyzing skills, career patterns, and preferences to surface candidates that traditional methods overlook.
                                    </p>
                                </div>

                                {/* Section 3 */}
                                <div>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(32px, 3vw, 48px)',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        2. Smarter Matching with AI Recruiters
                                    </h2>
                                    <p
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 200,
                                            fontSize: 'clamp(16px, 1.5vw, 24px)',
                                            lineHeight: '150%',
                                            textAlign: 'justify',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                        }}
                                    >
                                        AI-powered recruiters, like Hush's David, act as an intelligent bridge between employers and candidates. Instead of flooding hiring managers with hundreds of irrelevant résumés, AI filters down to a curated shortlist of qualified, interested individuals. For Employers: This means less time wasted and faster hires. For Candidates: Opportunities that match their goals arrive directly, without endless applications.
                                    </p>
                                </div>

                                {/* Section 4 */}
                                <div>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(32px, 3vw, 48px)',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        3. Protecting Candidate Privacy
                                    </h2>
                                    <p
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 200,
                                            fontSize: 'clamp(16px, 1.5vw, 24px)',
                                            lineHeight: '150%',
                                            textAlign: 'justify',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                        }}
                                    >
                                        One of the biggest barriers to adopting AI in recruiting is trust. At Hush, candidate privacy comes first. Profiles remain anonymous until candidates choose to engage. This ensures that talent can explore opportunities without risk to their current role.
                                    </p>
                                </div>

                                {/* Section 5 */}
                                <div>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(32px, 3vw, 48px)',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        4. Reducing Costs While Improving Quality
                                    </h2>
                                    <p
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 200,
                                            fontSize: 'clamp(16px, 1.5vw, 24px)',
                                            lineHeight: '150%',
                                            textAlign: 'justify',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                        }}
                                    >
                                        Traditional recruiting firms often charge high fees for low placement rates. AI-driven platforms cut costs by automating outreach, scheduling, and filtering, while actually delivering higher-quality matches. It's not just cheaper — it's smarter.
                                    </p>
                                </div>

                                {/* Section 6 */}
                                <div>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(32px, 3vw, 48px)',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        5. The Future of Hiring is AI-Powered
                                    </h2>
                                    <p
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 200,
                                            fontSize: 'clamp(16px, 1.5vw, 24px)',
                                            lineHeight: '150%',
                                            textAlign: 'justify',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                        }}
                                    >
                                        As industries evolve, so does the way we work. AI will continue to: Expand access to global talent. Remove unconscious bias from early screening. Make recruiting more efficient, transparent, and scalable. The result? A hiring ecosystem where companies fill roles faster, and candidates find the opportunities that truly fit.
                                    </p>
                                </div>

                                {/* Conclusion */}
                                <div>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(32px, 3vw, 48px)',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        Conclusion
                                    </h2>
                                    <p
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 200,
                                            fontSize: 'clamp(16px, 1.5vw, 24px)',
                                            lineHeight: '150%',
                                            textAlign: 'justify',
                                            letterSpacing: '-0.011em',
                                            color: '#FFFFFF',
                                        }}
                                    >
                                        AI isn't here to replace recruiters — it's here to make recruiting smarter. By focusing on passive talent, privacy, and efficiency, platforms like Hush are redefining how companies and candidates connect. The future of hiring is already here, and it's AI-powered.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Final CTA Section */}
                    <section
                        className="relative"
                        style={{
                            paddingTop: '176px',
                        }}
                    >
                        <div
                            className="relative overflow-hidden"
                            style={{
                                minHeight: '640px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {/* Pixel Texture Background with saturation blend mode */}
                            <div
                                className="absolute inset-0"
                                style={{
                                    backgroundImage: 'url(/background/modern_pixel2-optimized.png)',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 0.7, // Consistent with CallToAction
                                    zIndex: 0,
                                    mixBlendMode: 'saturation',
                                }}
                            />
                            <h2
                                style={{
                                    fontFamily: 'Manrope',
                                    fontWeight: 700,
                                    fontSize: 'clamp(48px, 5vw, 84px)',
                                    lineHeight: 'clamp(56px, 6vw, 90px)',
                                    textAlign: 'center',
                                    letterSpacing: '-0.05em',
                                    color: '#FFFFFF',
                                    maxWidth: '812px',
                                    marginBottom: '32px',
                                    position: 'relative',
                                    zIndex: 10,
                                }}
                            >
                                Join us in rethinking recruiting
                            </h2>

                            <p
                                style={{
                                    fontFamily: 'Manrope',
                                    fontWeight: 200,
                                    fontSize: 'clamp(20px, 2vw, 32px)',
                                    lineHeight: 'clamp(28px, 3vw, 44px)',
                                    textAlign: 'center',
                                    letterSpacing: '-0.05em',
                                    color: '#FFFFFF',
                                    maxWidth: '560px',
                                    marginBottom: '48px',
                                    position: 'relative',
                                    zIndex: 10,
                                }}
                            >
                                Choose your path and start with Hush today
                            </p>

                            <Link
                                to={CANDIDATE_APPLY_ROUTE}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '12px 30px',
                                    gap: '8px',
                                    background: 'linear-gradient(180deg, rgba(61, 66, 68, 0) -40.91%, rgba(158, 170, 176, 0.248) 132.95%)',
                                    boxShadow: 'inset 0px 8px 10px rgba(246, 249, 255, 0.08)',
                                    filter: 'drop-shadow(0px 6px 40px rgba(255, 255, 255, 0.08))',
                                    backdropFilter: 'blur(50px)',
                                    borderRadius: '10px',
                                    fontFamily: 'Inter',
                                    fontWeight: 500,
                                    fontSize: '24px',
                                    lineHeight: '20px',
                                    textAlign: 'center',
                                    color: '#FFFFFF',
                                    textDecoration: 'none',
                                    minWidth: '374px',
                                    height: '77px',
                                    position: 'relative',
                                    zIndex: 10,
                                }}
                            >
                                Get Started Free
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                        </div>
                    </section>
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default Blog;
